module.exports = __webpack_public_path__ + "static/media/newline4.d3438e40.jpg";